module.exports = __webpack_public_path__ + "img/TestLimitPopupImg.ce0fbb5f.jpeg";